import { configureStore } from '@reduxjs/toolkit';
import inboxReducer from './slices/inbox';
import organizationReducer from './slices/organization';
import roadmapReducer from './slices/roadmap'
import projectsReducer from './slices/projects'
import onboardingReducer from './slices/onboarding';
import notificationReducer from './slices/notification';
import resourcesReducer from './slices/resources';
import chatMessageReducer from './slices/chat';
import templatesReducer from './slices/templates';
import dashboardReducer from './slices/dashboard';
import timelineReducer from './slices/timeline';
import azureTeamsReducer from './slices/azureTeams';
import manageUsersReducer from './slices/manageUsers';
import settingsReducer from './slices/settings';
import integrationReducer from './slices/integration';
import levelMapListReducer from './slices/strategyMap';
import strategyMapViewReducer from './slices/strategyMapView';
import navigationInfoReducer from './slices/navigationInfo';
import viewsReducer from './slices/views';

import backgroundWorkerReducer from './slices/backgroundWorker';

const store = configureStore({
    reducer: {
        inbox: inboxReducer,
        organization: organizationReducer,
        roadmap: roadmapReducer,
        projects: projectsReducer,
        onboarding: onboardingReducer,
        notification: notificationReducer,
        resources: resourcesReducer,
        chatMessages: chatMessageReducer,
        templates: templatesReducer,
        dashboard: dashboardReducer,
        timeline: timelineReducer,
        manageUsers: manageUsersReducer,
        azureTeams: azureTeamsReducer,
        settings: settingsReducer,
        integration: integrationReducer,
        levelMapList: levelMapListReducer,
        strategyMapView: strategyMapViewReducer,
        navigationInfo: navigationInfoReducer,
        views: viewsReducer,
        background_worker: backgroundWorkerReducer,
    },
})

export type ReduxStateType = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;